import axios from 'axios';

/** 新しい nearest-point 要求で直前の GET をキャンセル */
let nearestPointCancelSource = null;

export const LIST_A_MEASUREMENT_DISTANCE_FROM_CROSS_SECTION_TUNNEL = '[CTM A MEASUREMENT] LIST A MEASUREMENT DISTANCE FROM CROSS SECTION TUNNEL';
export const LIST_A_MEASUREMENT_SETTLEMENT_HISTORY  = '[CTM A MEASUREMENT] LIST A MEASUREMENT SETTLEMENT HISTORY';
export const GET_A_MEASUREMENT_THRESHOLD  = '[CTM A MEASUREMENT] GET A MEASUREMENT THRESHOLD';
export const UPDATE_A_MEASUREMENT_THRESHOLD = '[CTM A MEASUREMENT] UPDATE A MEASUREMENT THRESHOLD';
export const SET_MEASUREMENT = '[CTM A MEASUREMENT] SET MEASUREMENT';
export const GET_NEAREST_POINT = '[CTM A MEASUREMENT] GET NEAREST POINT';
export const GET_PREV_NEAREST_POINT = '[CTM A MEASUREMENT] GET PREV_NEAREST POINT';
export const GET_NEXT_NEAREST_POINT = '[CTM A MEASUREMENT] GET NEXT NEAREST POINT';
export const GET_AXIS = '[CTM A MEASUREMENT] GET AXIS';
export const LIST_A_MEASUREMENT_CONSTRUCTION_INFO = '[CTM A MEASUREMENT] LIST A MEASUREMENT CONSTRUCTION INFO';
export const SET_MAIN_CHART = '[CTM A MEASUREMENT] SET MAIN CHART'

/** リクエスト開始時の工事コードと persist が一致する場合のみストアを更新（遅延レスポンス対策） */
function persistProjectStillSelected(capturedCode) {
    if (capturedCode == null || capturedCode === '') {
        return false;
    }
    try {
        const raw = localStorage.getItem('persistProjectSelected');
        const cur = raw ? JSON.parse(raw) : null;
        if (!cur || typeof cur !== 'object') {
            return false;
        }
        return cur.projectCode === capturedCode;
    } catch (e) {
        return false;
    }
}

export const aMeasurementDistFromTd = (tdValue) => async dispatch => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    let project = JSON.parse(localStorage.getItem('persistProjectSelected'));
    let projectCode = project['projectCode'];
    const capturedProjectCode = projectCode;

    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/a-measurement-dist-from-td?const_cd='+projectCode+
                                                                                                            '&tunnel_dist='+tdValue, {
        headers: { Authorization: `Token ${token}` }
    });

    return request.then(response => {
        console.log("aMeasurementDistFromTd.aMeasurementDistFromTd>>>>>>>>>> ", response)
        if (response.data.data) {
        if (!persistProjectStillSelected(capturedProjectCode)) {
            return;
        }
        return dispatch({
            type: LIST_A_MEASUREMENT_DISTANCE_FROM_CROSS_SECTION_TUNNEL,
            data: response.data.data,
        });
        } else {
        //reject(response.data.error);
        }
    });
};

export const aMeasurementSettlementHistory = (tdValue,date_range,start_date) => async dispatch => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    let project = JSON.parse(localStorage.getItem('persistProjectSelected'));
    let projectCode = project['projectCode'];
    const capturedProjectCode = projectCode;

    if (date_range === undefined){
        date_range = ''
    } 
    if (start_date === undefined || start_date === false){
        start_date = ''
    } 

    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/a-measurement-settle?const_cd='+projectCode+
                                                                        '&tunnel_dist='+tdValue+
                                                                        '&date_range='+date_range+
                                                                        '&start_date='+start_date, {
        headers: { Authorization: `Token ${token}` }
    });

    return request.then(response => {
        console.log("aMeasurementSettlementHistory.aMeasurementSettlementHistory>>>>>>>>>> ", response);
        if (response.data.data) {
        if (!persistProjectStillSelected(capturedProjectCode)) {
            return;
        }
        return dispatch({
            type: LIST_A_MEASUREMENT_SETTLEMENT_HISTORY,
            data: response.data.data,
        });
        } else {
        //reject(response.data.error);
        }
    });
};

export const aMeasurementThreshold = (tdValue) => async dispatch => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    let project = JSON.parse(localStorage.getItem('persistProjectSelected'));
    let projectCode = project['projectCode'];
    const capturedProjectCode = projectCode;

    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/a-measurement-threshold?const_cd='+projectCode+'&tunnel_dist='+tdValue, {
        headers: { Authorization: `Token ${token}` }
    });

    return request.then(response => {
        console.log("aMeasurementSettlementHistory.aMeasurementThreshold>>>>>>>>>> ", response);
        if (response.data.data) {
        if (!persistProjectStillSelected(capturedProjectCode)) {
            return;
        }
        return dispatch({
            type: GET_A_MEASUREMENT_THRESHOLD,
            data: response.data.data,
        });
        } else {
        //reject(response.data.error);
        }
    });
};

export function updateAMeasurementThreshold(tr, tdValue) {
	return async (dispatch, getState) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
        let project = JSON.parse(localStorage.getItem('persistProjectSelected'));
        let projectCode = project['projectCode'];
        const capturedProjectCode = projectCode;

        let name = tr.name
        let value = tr.value
        let tunnelDistance = tdValue

        console.log("updateAMeasurementThreshold ============> ", name, value, tunnelDistance);

        const dataForm = new FormData();
            dataForm.append('const_cd', projectCode);
            dataForm.append('tunnel_dist', tunnelDistance);
            dataForm.append(name, value);
        
		const config = {
			headers: { Authorization: `Token ${token}` }
		};
		const bodyParameters = dataForm;
		
		await axios.put(process.env.REACT_APP_SERVER + '/api/ctm/a-measurement-threshold?const_cd='+projectCode+
                                                                                                        '&tunnel_dist='+tunnelDistance, 
									bodyParameters,
									config                      
		)
        .then(response => {
            console.log("aMeasurementSettlementHistory.updateAMeasurementThreshold>>>>>>>>>> ", response);
            if (!persistProjectStillSelected(capturedProjectCode)) {
                return;
            }
            return dispatch({
                type: UPDATE_A_MEASUREMENT_THRESHOLD,
                data:response.data.data
            });
        })
        .catch(function (error) {
            console.log("error ?????????????????", error);
            if (error.response) {
              // Request made and server responded
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }
            /*return dispatch({
                type: ERROR_API,
            })*/;
        
        });


		
	}

}

export const setMeasurement = (tunnelDistance) => async dispatch => {

    return dispatch({
        type: SET_MEASUREMENT,
        data: tunnelDistance,
    });

};

export const getNearestPoint = (tunnelDistance) => async dispatch => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    let project = JSON.parse(localStorage.getItem('persistProjectSelected'));
    let projectCode = project['projectCode'];
    const capturedProjectCode = projectCode;
    //let td = tunnelDistance && tunnelDistance.toFloat()
    //let ctm = JSON.parse(localStorage.getItem('ctm'));
    //let tunnelDistance = ctm['TDSelected'];
    console.log("projectCode =======> ", projectCode);
    console.log("tunnelDistance =======> ", tunnelDistance);
    console.log('getNearestPoint:/api/ctm/nearest-measurement-point?const_cd='+projectCode+'&tunnel_dist='+tunnelDistance);
    if (nearestPointCancelSource) {
        nearestPointCancelSource.cancel('superseded');
    }
    const source = axios.CancelToken.source();
    nearestPointCancelSource = source;
    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/nearest-measurement-point?const_cd='+projectCode+'&tunnel_dist='+tunnelDistance, {
        headers: { Authorization: `Token ${token}` },
        cancelToken: source.token,
    });

    return request.then(response => {
        console.log("aMeasurementSettlementHistory.getNearestPoint>>>>>>>>>> ", response);
        //console.log("getNearestPoint request ", response)
        if (response.data.data) {
        if (!persistProjectStillSelected(capturedProjectCode)) {
            return;
        }
        return dispatch({
            type: GET_NEAREST_POINT,
            data: response.data.data,
        });
        } else {
        //reject(response.data.error);
        }
    }).catch((err) => {
        if (axios.isCancel(err)) {
            return;
        }
        console.log('getNearestPoint error', err);
    }).finally(() => {
        if (nearestPointCancelSource === source) {
            nearestPointCancelSource = null;
        }
    });
};

export const getPrevNearestPoint = (tunnelDistance) => async dispatch => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    let project = JSON.parse(localStorage.getItem('persistProjectSelected'));
    let projectCode = project['projectCode'];
    const capturedProjectCode = projectCode;
    //let td = tunnelDistance && tunnelDistance.toFloat()
    //let ctm = JSON.parse(localStorage.getItem('ctm'));
    //let tunnelDistance = ctm['TDSelected'];
    console.log("projectCode =======> ", projectCode);
    console.log("tunnelDistance =======> ", tunnelDistance);
    console.log('getPrevNearestPoint:/api/ctm/prev-nearest-measurement-point?const_cd='+projectCode+'&tunnel_dist='+tunnelDistance);
    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/prev-nearest-measurement-point?const_cd='+projectCode+'&tunnel_dist='+tunnelDistance, {
        headers: { Authorization: `Token ${token}` }
    });

    return request.then(response => {
        console.log("aMeasurementSettlementHistory.getPrevNearestPoint>>>>>>>>>> ", response);
        //console.log("getNearestPoint request ", response)
        if (response.data.data) {
        if (!persistProjectStillSelected(capturedProjectCode)) {
            return;
        }
        return dispatch({
            type: GET_PREV_NEAREST_POINT,
            data: response.data.data,
        });
        } else {
        //reject(response.data.error);
        }
    });
};

export const getNextNearestPoint = (tunnelDistance) => async dispatch => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    let project = JSON.parse(localStorage.getItem('persistProjectSelected'));
    let projectCode = project['projectCode'];
    const capturedProjectCode = projectCode;
    //let td = tunnelDistance && tunnelDistance.toFloat()
    //let ctm = JSON.parse(localStorage.getItem('ctm'));
    //let tunnelDistance = ctm['TDSelected'];
    console.log("projectCode =======> ", projectCode);
    console.log("tunnelDistance =======> ", tunnelDistance);
    console.log('getNextNearestPoint:/api/ctm/next-nearest-measurement-point?const_cd='+projectCode+'&tunnel_dist='+tunnelDistance);
    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/next-nearest-measurement-point?const_cd='+projectCode+'&tunnel_dist='+tunnelDistance, {
        headers: { Authorization: `Token ${token}` }
    });

    return request.then(response => {
        console.log("aMeasurementSettlementHistory.getNextNearestPoint>>>>>>>>>> ", response);
        //console.log("getNearestPoint request ", response)
        if (response.data.data) {
        if (!persistProjectStillSelected(capturedProjectCode)) {
            return;
        }
        return dispatch({
            type: GET_NEXT_NEAREST_POINT,
            data: response.data.data,
        });
        } else {
        //reject(response.data.error);
        }
    });
};


export const getAxis = (tdValue,date_range,start_date) => async dispatch => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    let project = JSON.parse(localStorage.getItem('persistProjectSelected'));
    let projectCode = project['projectCode'];
    const capturedProjectCode = projectCode;
    
    if (date_range === undefined){
        date_range = ''
    } 
    if (start_date === undefined || start_date === false){
        start_date = ''
    } 

    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/a-measurement-axes-range?const_cd='+projectCode+
                                                                                                '&tunnel_dist='+tdValue+
                                                                                                '&date_range='+date_range+
                                                                                                '&start_date='+start_date, {
        headers: { Authorization: `Token ${token}` }
    });

    return request.then(response => {
        console.log("aMeasurementSettlementHistory.getAxis>>>>>>>>>> ", response);
            //console.log('getAxis => ', response.data)
        if (response.data.data) {
        if (!persistProjectStillSelected(capturedProjectCode)) {
            return;
        }
        return dispatch({
            type: GET_AXIS,
            data: response.data.data,
        });
        } else {
        //reject(response.data.error);
        }
    });
};

export const aMeasurementConstructionInfo = (tdValue) => async dispatch => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    let project = JSON.parse(localStorage.getItem('persistProjectSelected'));
    let projectCode = project['projectCode'];
    const capturedProjectCode = projectCode;
console.log("token : " + token);
console.log("projectCode : " + projectCode);
console.log("tdValue : " + tdValue);
    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/a-measurement-construction-info?const_cd='+projectCode+
                                                                        '&tunnel_dist='+tdValue, {
        headers: { Authorization: `Token ${token}` }
    });

    return request.then(response => {
        console.log("aMeasurementSettlementHistory.aMeasurementConstructionInfo>>>>>>>>>> ", response);
        if (response.data.data) {
        if (!persistProjectStillSelected(capturedProjectCode)) {
            return;
        }
        return dispatch({
            type: LIST_A_MEASUREMENT_CONSTRUCTION_INFO,
            data: response.data.data,
        });
        } else {
        //reject(response.data.error);
        }
    });
};

export const setMainChart = (mainChart) => async dispatch => {

    return dispatch({
        type: SET_MAIN_CHART,
        data: mainChart,
    });

};

/**
 * TD 切替時に A 測定グラフ用の GET を並列実行する（個別 thunk の挙動・persist ガードはそのまま）。
 * @param {string|number} tdValue
 * @param {{ isInit?: boolean, axisDateRange?: string, axisStartDate?: string }} axisOptions isInit 時のみ軸 API に日付引数を渡す
 */
export const fetchAMeasurementGraphDataParallel = (tdValue, axisOptions = {}) => async (dispatch) => {
    const isInit = Boolean(axisOptions.isInit);
    const dateRange = isInit ? (axisOptions.axisDateRange ?? '') : '';
    const startDate = isInit ? (axisOptions.axisStartDate ?? '') : '';

    await Promise.allSettled([
        dispatch(aMeasurementDistFromTd(tdValue)),
        dispatch(aMeasurementThreshold(tdValue)),
        dispatch(aMeasurementConstructionInfo(tdValue)),
        dispatch(aMeasurementSettlementHistory(tdValue)),
        dispatch(getAxis(tdValue, dateRange, startDate)),
    ]);
};
